import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Typography } from '@material-ui/core';

const styles = theme => ({
  root: {
    width: "auto",
  },
  title: {
    fontWeight: 550,
  },
});

class SpecialFeaturesResultRenderer extends Component {
  render() {
    if (!this.props.features) return null;

    const { classes } = this.props;

    const resultRows = this.props.features.map((row, rowIndex) => {
      return (
        <TableRow key={rowIndex}>
          <TableCell>{rowIndex + 1}</TableCell>
          <TableCell>
            {row.map((value, index) => <Typography key={index}><span className={classes.title}>{value.title}.</span> {value.description}</Typography>)}
          </TableCell>
        </TableRow>
      );
    });

    return (
      <Paper className={classes.root}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>Row</TableCell>
              <TableCell>Features</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>{resultRows}</TableBody>
        </Table>
      </Paper>
    );
  }
}

SpecialFeaturesResultRenderer.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SpecialFeaturesResultRenderer);


// WEBPACK FOOTER //
// ./src/item-helpers/SpecialFeaturesResultRenderer.js